import qs from "qs";
import authAxios, { authHeader } from "../data";
import { IFillableFormRequest } from "../../pages/Administration/FillableForms/types";

const fetchAll = async (req: any) => {
  const response = await authAxios.get("/api/FillableFormTemplates", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async () => {
  const response = await authAxios.get("/api/FillableFormTemplates/Count", {
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/FillableFormTemplates/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const download = async (id: string) => {
  const response = await authAxios.get(
    `/api/FillableFormTemplates/${id}/download`,
    {
      paramsSerializer: (params) => {
        return qs.stringify(params);
      },
      headers: authHeader(),
      responseType: "blob",
    },
  );

  return response.data;
};

const create = async (req: IFillableFormRequest) => {
  const response = await authAxios.post("/api/FillableFormTemplates", req, {
    headers: authHeader(),
  });

  return response.data;
};

const edit = async (entry: IFillableFormRequest, id: string) => {
  const response = await authAxios.put(
    "/api/FillableFormTemplates/" + id,
    entry,
    {
      headers: authHeader(),
    },
  );

  return response.data;
};

const remove = async (id: string) => {
  const response = await authAxios.delete("/api/FillableFormTemplates/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const FillableFormsService = {
  fetchAll,
  fetchCount,
  fetch,
  download,
  remove,
  create,
  edit,
};

export default FillableFormsService;
